import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4889c50d")

_pushScopeId("data-v-4889c50d")
const _hoisted_1 = { class: "p-fluid" }
const _hoisted_2 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_3 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_4 = /*#__PURE__*/_createVNode("label", { for: "date" }, "Chọn ngày để xem", -1)
const _hoisted_5 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_6 = /*#__PURE__*/_createVNode("label", null, "Tình trạng khám chữa bệnh", -1)
const _hoisted_7 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_8 = /*#__PURE__*/_createVNode("label", null, "Chọn khoa khám bệnh", -1)
const _hoisted_9 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_10 = {
  class: "p-input-icon-left",
  style: {"width":"25em"}
}
const _hoisted_11 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_12 = { class: "center" }
const _hoisted_13 = {
  key: 0,
  class: "active"
}
const _hoisted_14 = {
  key: 1,
  class: "deactive"
}
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Không có lượt đăng ký khám bệnh. ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ConfirmPopup = _resolveComponent("ConfirmPopup")
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Button = _resolveComponent("Button")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Column = _resolveComponent("Column")
  const _component_router_link = _resolveComponent("router-link")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Panel = _resolveComponent("Panel")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_ConfirmPopup),
    _createVNode(_component_Panel, { header: "Xem lịch đăng ký" }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode(_component_Calendar, {
                id: "date",
                modelValue: $setup.date,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ($setup.date = $event)),
                selectionMode: "single",
                dateFormat: "dd/mm/yy",
                showButtonBar: true,
                showIcon: true,
                manualInput: false,
                disabled: $setup.isLoading,
                monthNavigator: true,
                yearNavigator: true,
                yearRange: "2000:2100",
                onDateSelect: _cache[2] || (_cache[2] = ($event: any) => ($setup.loadBook()))
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _createVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_Dropdown, {
                id: "status",
                modelValue: $setup.selectStatus,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ($setup.selectStatus = $event)),
                options: $setup.status,
                optionLabel: "label",
                optionValue: "value",
                onChange: $setup.select
              }, null, 8, ["modelValue", "options", "onChange"])
            ]),
            _createVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_Dropdown, {
                id: "team",
                filter: true,
                showClear: true,
                modelValue: $setup.selectTeam,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ($setup.selectTeam = $event)),
                options: $setup.teams,
                optionLabel: "name",
                optionValue: "name",
                placeholder: "Vui lòng lựa chọn khoa khám...",
                onChange: $setup.onSelectTeam
              }, null, 8, ["modelValue", "options", "onChange"])
            ])
          ]),
          _createVNode(_component_DataTable, {
            loading: $setup.isLoading,
            value: $setup.books,
            paginator: true,
            stripedRows: "",
            filters: $setup.filters,
            "onUpdate:filters": _cache[7] || (_cache[7] = ($event: any) => ($setup.filters = $event)),
            rows: 10,
            rowsPerPageOptions: [10,25,50],
            rowHover: true,
            paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
            globalFilterFields: ['full_name','phone_number'],
            columnResizeMode: "fit | expand",
            currentPageReportTemplate: "Có tất cả {totalRecords} lượt"
          }, {
            header: _withId(() => [
              _createVNode("div", _hoisted_9, [
                _createVNode(_component_Button, {
                  type: "button",
                  icon: "pi pi-filter-slash",
                  label: "Xoá",
                  class: "p-button-outlined",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.clearFilter())),
                  style: {"width":"6em"}
                }),
                _createVNode("span", _hoisted_10, [
                  _hoisted_11,
                  _createVNode(_component_InputText, {
                    modelValue: $setup.filters['global'].value,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ($setup.filters['global'].value = $event)),
                    placeholder: "Tìm theo tên bệnh nhân hoặc số điện thoại..."
                  }, null, 8, ["modelValue"])
                ])
              ])
            ]),
            paginatorLeft: _withId(() => [
              _createVNode(_component_Button, {
                type: "button",
                icon: "pi pi-refresh",
                class: "p-button-text",
                onClick: $setup.loadBook
              }, null, 8, ["onClick"])
            ]),
            empty: _withId(() => [
              _hoisted_15
            ]),
            default: _withId(() => [
              _createVNode(_component_Column, {
                field: "full_name",
                header: "Họ và tên",
                sortable: ""
              }),
              _createVNode(_component_Column, {
                field: "phone_number",
                header: "Số điện thoại"
              }),
              _createVNode(_component_Column, {
                field: "symptoms",
                header: "Triệu chứng"
              }),
              _createVNode(_component_Column, {
                field: "team",
                header: "Khoa khám bệnh",
                sortable: ""
              }),
              _createVNode(_component_Column, {
                field: "formatted_time",
                header: "Thời gian"
              }),
              _createVNode(_component_Column, {
                header: "Tình trạng",
                sortable: ""
              }, {
                body: _withId((slotProps) => [
                  _createVNode("div", _hoisted_12, [
                    _createVNode(_component_router_link, {
                      style: {"text-decoration":"none !important"},
                      to: { name: 'book', params: {id: slotProps.data.id}}
                    }, {
                      default: _withId(() => [
                        (!slotProps.data.checked)
                          ? (_openBlock(), _createBlock(_component_Button, {
                              key: 0,
                              label: "Chờ khám",
                              type: "button",
                              icon: "pi pi-circle-off",
                              align: "center"
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["to"]),
                    (slotProps.data.checked)
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 0,
                          label: "Đã khám",
                          disabled: "",
                          type: "button",
                          icon: "pi pi-check-circle",
                          align: "center",
                          style: {"color":"black","background-color":"gray"}
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                header: "Chỉnh sửa",
                style: {"width":"10em"}
              }, {
                body: _withId((slotProps) => [
                  (!slotProps.data.checked)
                    ? (_openBlock(), _createBlock("div", _hoisted_13, [
                        _createVNode(_component_router_link, {
                          style: {"text-decoration":"none !important"},
                          to: { name: 'updateBook', params: {id: slotProps.data.id}}
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_Button, {
                              type: "button",
                              label: "Đổi khoa",
                              icon: "pi pi-pencil"
                            })
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_14, [
                        _createVNode(_component_Button, {
                          disabled: "",
                          type: "button",
                          label: "Đổi khoa",
                          icon: "pi pi-pencil",
                          style: {"color":"black","background-color":"gray"}
                        })
                      ]))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["loading", "value", "filters"])
        ])
      ]),
      _: 1
    })
  ], 64))
})